import React from 'react'

const MailIcon = () => {
    return ( <svg xmlns="http://www.w3.org/2000/svg" width="36.722" height="26.164" viewBox="0 0 36.722 26.164">
    <path id="Path_142" data-name="Path 142" d="M41.936,207.853v26.163H78.658V207.853Zm29.16,3.811-10.8,8.209-10.8-8.209ZM45.747,230.205V213.6L60.3,224.66,74.847,213.6v16.6Z" transform="translate(-41.936 -207.853)" fill="#818181"/>
  </svg>
   );
}
 
export default MailIcon;